module.exports = __webpack_public_path__ + "img/king-charles-i-and-queen-henrietta-maria.adbf8c96.png";